import React from 'react';
import { useSearchParams, useParams, useLocation } from 'react-router-dom';

import Icons from 'components/Icons';
import TopBar from 'components/TopBar';
import { track } from 'common/analytics';

function GameTopBar() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { language } = useParams();
  const location = useLocation();
  const isUnlimited = location.pathname.includes('/unlimited');
  const title = (
    <div className="game-title">
      Bokstavo
      {isUnlimited && <Icons.Unlimited />}
    </div>
  );
  const rightComponent = (
    <button
      type="button"
      className="btn"
      onClick={() => {
        setSearchParams({ ...searchParams, open: 'instructions' });
        track.dailyHelpButtonClick(language);
      }}
    >
      <Icons.Instructions />
    </button>
  );
  return <TopBar title={title} rightComponent={rightComponent} />;
}

export default GameTopBar;
